import { useEffect } from 'react';
import { useTimeOnPage } from '@3plearning/mx-teacher-analytics/react';

import { trackEvent, trackSession, getAnalytics, ANALYTICS_EVENTS } from '../helpers/analytics';

export default function usePageTracking(isOneRosterActivatedSchool) {
    useTimeOnPage(getAnalytics());

    useEffect(() => {
        trackEvent(ANALYTICS_EVENTS.pageView, { is_one_roster_activated_school: isOneRosterActivatedSchool });
        trackSession(window.location.pathname);
    }, [isOneRosterActivatedSchool]);
}



// WEBPACK FOOTER //
// ./hooks/use-page-tracking.js